import { render, staticRenderFns } from "./TableDynamicServerSide.vue?vue&type=template&id=0d4a1ddf&scoped=true&"
import script from "./TableDynamicServerSide.vue?vue&type=script&lang=js&"
export * from "./TableDynamicServerSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a1ddf",
  null
  
)

export default component.exports